<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <b-overlay :show="loading">
      <!-- Header -->
      <header id="header" class="bg-white shadow-sm">
        <div class="container mx-auto px-4 py-4">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4 w-full">
              <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                {{ activeFolder.name }} / Regla:
              </span>
              <input
                type="text"
                class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2"
                placeholder="Ingrese el nombre de la regla"
                v-model="ruleState.name"
              >
              <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                Prioridad:
              </span>
              <input
                type="text"
                class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2"
                placeholder="Ingrese el nombre de la regla"
                v-model="ruleState.priority"
                min="0"
                max="100"
              >
            </div>
          </div>
        </div>
      </header>
      <!-- Main Content -->
      <main class="container mx-auto px-4 py-8">
        <!-- Rule Builder Form -->
        <div id="rule-builder" class="bg-white rounded-xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-medium">Condiciones</h2>
          </div>
          <!-- Conditions Builder -->
          <div id="conditions-builder" class="space-y-6">
            <ConditionRenderer
              v-for="(condition, index) in ruleState.conditions"
              :key="index"
              :index="index"
              :condition="condition"
              :jsonPathTypes="jsonPathTypes"
            />
          </div>
        </div>
      </main>
      <main class="container mx-auto px-4 py-8">
        <!-- Rule Builder Form -->
        <div id="rule-builder" class="bg-white rounded-xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-medium">Condiciones internas</h2>
          </div>
          <!-- Metadata Builder -->
          <div id="metadata-builder" class="space-y-6">
            <MetadataForm
              :ruleState="ruleState"
              @saveMeta="saveMeta($event)"
            />
          </div>
        </div>
      </main>
      <main class="container mx-auto px-4 py-8">
        <!-- Rule Builder Form -->
        <div id="rule-builder" class="bg-white rounded-xl shadow-sm p-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-medium">Acciones</h2>
          </div>
          <div class="actions-container">
            <!-- Actions Builder -->
            <ActionForm
              v-for="(condition, index) in ruleState.actions"
              :key="index"
              :index="index"
              :actiondata="condition"
              @removeAction="removeAction(index)"
            />
            <b-button
              title="Agregar nueva acción"
              v-b-tooltip.hover="'Agregar nueva acción'"
              size="sm"
              variant="outline-primary"
              class="btn-icon mt-2 text-center shadow"
              @click="addAction()"
            >
              <feather-icon icon="PlusIcon"/>
            </b-button>
          </div>
          <!-- Form Actions -->
          <div id="rule-builder" class="bg-white rounded-xl shadow-sm p-6">
            <!-- Form Actions -->
            <div id="form-actions" class="mt-8 flex justify-end space-x-4">
              <b-button
                variant="success"
                @click="saveRule()"
              >
                Guardar
              </b-button>
            </div>
          </div>
        </div>
      </main>
      <main class="container mx-auto px-4 py-8" v-if="isSuperAdmin">
        <app-collapse-item>
          <template slot="header" slot-scope="props">
            <feather-icon
              :icon="!props.visible?'ChevronUpIcon':'ChevronDownIcon'"
              size="18"
              class="mr-1 icon-header"
            />
            <span class="lead collapse-title">Regla como JSON</span>
          </template>
          <div id="preview-section" class=" bg-white rounded-xl shadow-sm p-6">
            <div class="bg-gray-900 rounded-lg p-4">
              <pre class="text-green-400 text-sm overflow-x-auto">{{ jsonRule }}</pre>
            </div>
          </div>
        </app-collapse-item>
      </main>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { BButton } from 'bootstrap-vue';

import ConditionRenderer from '@/febos/global/rules/components/ConditionRenderer';
import ActionForm from '@/febos/global/rules/components/ActionForm';
import MetadataForm from '@/febos/global/rules/components/MetadataForm';
import {
  ACTION_TYPES,
  buildEmptyGroup,
  CONDITION_TYPES,
  jsonPathTypes
} from '@/febos/global/rules/util';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem';

export default {
  name: 'RulesView',
  data() {
    return {
      loading: true,
      ruleId: null,
      jsonPathTypes,
      ruleState: {
        name: 'Sin Nombre',
        priority: 0,
        conditions: [buildEmptyGroup()],
        actions: [],
        metadata: [],
      }
    };
  },
  components: {
    AppCollapseItem,
    BButton,
    ConditionRenderer,
    ActionForm,
    MetadataForm,
  },
  mounted() {
    this.loadRules();
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('RepositoryRules', [
      'getActiveFolder',
      'getRules'
    ]),
    activeFolder() {
      return this.getActiveFolder(this.$route.params.folderId);
    },
    jsonRule() {
      return JSON.stringify(this.ruleState, null, 2);
    },
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('RepositoryRules', [
      'loadRulesFolder',
      'saveRulesFolder'
    ]),
    saveMeta(interMeta) {
      const existMeta = (this.ruleState.metadata || []).some((meta) => meta.key === interMeta.key);
      if (existMeta) {
        this.ruleState.metadata.forEach((item) => {
          if (item.key === interMeta.key) {
            // eslint-disable-next-line no-param-reassign
            item.value = interMeta.value;
          }
        });
      } else {
        this.ruleState.metadata.push(interMeta);
      }
    },
    async loadRules() {
      this.loading = true;
      const { ruleId } = this.$route.params;
      if (ruleId && ruleId !== 'new' && ruleId !== 'undefined') {
        this.ruleId = ruleId;
        const config = {
          repositoryId: this.$route.params.repositoryId,
          folderId: this.$route.params.folderId,
          ruleId: this.$route.params.ruleId
        };
        this.ruleState = await this.loadRulesFolder(config);
      }
      this.loading = false;
    },
    validateCondition(condition) {
      if (!condition.type) {
        this.$bvToast.toast(
          'Debe agregar un tipo de condición',
          {
            title: '¡Error!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true
          }
        );
        throw new Error('Debe agregar un tipo de condición');
      }
      if (condition.type === CONDITION_TYPES.GROUP) {
        if (!condition.value) {
          this.$bvToast.toast(
            'Debe agregar un valor de condición',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar un valor de condición');
        }
        if (!condition.conditions || condition.conditions.length === 0) {
          this.$bvToast.toast(
            'Debe agregar al menos una condición',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar al menos una condición');
        }
        condition.conditions.forEach((subCondition) => {
          this.validateCondition(subCondition);
        });
      } else if (condition.type === CONDITION_TYPES.CONDITION) {
        if (!condition.operator) {
          this.$bvToast.toast(
            'Debe agregar un operador de condición',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar un operador de condición');
        }
        if (!condition.value) {
          this.$bvToast.toast(
            'Debe agregar un valor de condición',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar un valor de condición');
        }
        if (!condition.path) {
          this.$bvToast.toast(
            'Debe agregar un path de condición',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar un path de condición');
        }
      }
    },
    validateState(state) {
      if (!state.name) {
        this.$bvToast.toast(
          'El nombre de la regla es requerido',
          {
            title: '¡Error!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true
          }
        );
        throw new Error('El nombre de la regla es requerido');
      }
      if (state.conditions.length === 0) {
        this.$bvToast.toast(
          'Debe agregar al menos una condición',
          {
            title: '¡Error!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true
          }
        );
        throw new Error('Debe agregar al menos una condición');
      }
      state.conditions.forEach((condition) => {
        this.validateCondition(condition);
      });
      if (state.actions.length === 0) {
        this.$bvToast.toast(
          'Debe agregar al menos una acción',
          {
            title: '¡Error!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true
          }
        );
        throw new Error('Debe agregar al menos una acción');
      }
      state.actions.forEach((action) => {
        if (!action.type) {
          this.$bvToast.toast(
            'Debe agregar un tipo de acción',
            {
              title: '¡Error!',
              variant: 'danger',
              pauseOnHover: true,
              solid: true
            }
          );
          throw new Error('Debe agregar un tipo de acción');
        }
        if (action.type === ACTION_TYPES.APPROVAL) {
          if (!action.name) {
            this.$bvToast.toast(
              'Debe agregar un nombre de aprobación',
              {
                title: '¡Error!',
                variant: 'danger',
                pauseOnHover: true,
                solid: true
              }
            );
            throw new Error('Debe agregar un nombre de acción');
          }
          if (!action.description) {
            this.$bvToast.toast(
              'Debe agregar una descripción de aprobación',
              {
                title: '¡Error!',
                variant: 'danger',
                pauseOnHover: true,
                solid: true
              }
            );
            throw new Error('Debe agregar un nombre de acción');
          }
          if (!action.flow) {
            this.$bvToast.toast(
              'Debe seleccionar un flujo de aprobación',
              {
                title: '¡Error!',
                variant: 'danger',
                pauseOnHover: true,
                solid: true
              }
            );
            throw new Error('Debe agregar un nombre de acción');
          }
        }
      });
    },
    async saveRule() {
      this.loading = true;
      try {
        const state = {
          ...this.ruleState,
          ...((this.ruleId && this.ruleId !== 'new') && { ruleId: this.ruleId }),
        };
        this.validateState(state);
        const config = {
          repositoryId: this.$route.params.repositoryId,
          folderId: this.$route.params.folderId,
          state
        };
        this.ruleState = await this.saveRulesFolder(config);
        this.ruleId = this.ruleState.ruleId;
        this.$bvToast.toast(
          'Se ha guardado la configuración',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true
          }
        );
      } finally {
        this.loading = false;
      }
    },
    addAction() {
      this.ruleState.actions.push({
        type: '',
        fromOrigingUser: false
      });
    },
    removeAction(index) {
      this.ruleState.actions.splice(index, 1);
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.fb-bg-primary {
  background-color: rgb(var(--vs-primary)) !important;
}
</style>
